import { Component, OnInit, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { ShoppingList, ShoppingListItem } from 'src/app/models/shopping-list.model';

@Component({
  selector: 'app-shopping-list',
  templateUrl: './shopping-list.component.html',
  styleUrls: ['./shopping-list.component.scss'],
})
export class ShoppingListComponent implements OnInit {
  @Input() set shoppingList(val: ShoppingList){
    this.title = val.title;
    this.items = val.items;
  }

  title: string;
  items: ShoppingListItem[] = [];

  constructor(
    public modalController: ModalController,
  ) { }

  ngOnInit() {
  }

  close() {
    this.modalController.dismiss();
  }

  itemCheckedChanged(e, item: ShoppingListItem) {
    item.isChecked = e.detail.checked;
  }
}
